"use client";

import { useEffect } from "react";

// 2026-10-11 E4 (cierre, split del entry): host diferido del init de Sentry.
// Se monta vía next/dynamic en el layout raíz (como el resto de hosts
// no-críticos): el SDK vive tras una frontera async real y nunca en el
// first-load. Dispara UNA vez tras requestIdleCallback (fallback 1500ms);
// error.tsx/global-error.tsx conservan su dynamic import como red.
export function SentryLazyInit(): null {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const run = (): void => {
      void import("@/lib/sentry-lazy-init")
        .then((m) => m.initSentryClient())
        .catch(() => {
          // fail-open: sin SDK no hay reporte, la app vale igual.
        });
    };
    const w = window as unknown as {
      requestIdleCallback?: (
        cb: () => void,
        opts?: { timeout: number },
      ) => void;
    };
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 1500);
    }
  }, []);
  return null;
}
